import { Typography } from "@mui/material";
import { useSelector } from "react-redux";
import { getRightPackageUom } from "../../../util/function";
import { mealTypesEnum } from "../../../util/enum";

const PrescriptionView = ({ prescriptions }) => {
  const reqDet = useSelector((state) => state?.pet?.complaintSummary?.data);
  const { clinicStocks } = useSelector((state) => state?.clinic);

  const getBatchList = (stockId = null) => {
    if (!stockId) return [];
    const reqStock = clinicStocks?.data?.find(
      (stc) => stc?.stockId === stockId,
    );
    return reqStock?.stockBatch ?? [];
  };

  const renderData = (li, currPrd) => {
    return (
      <div className="flex-row ph10 mv5" key={`rec_${li?.id ?? li?.i}`}>
        <div className="w30Per pr5">
          <Typography className="fs12 font-medium black4">
            {li?.name ?? li?.plName}
          </Typography>
        </div>
        <div className="w10Per pr5">
          <Typography className="fs12 font-medium black4">
            {li?.quantity ?? li?.qty ?? "1"}
            {li?.subUnit === "Unit" || li?.unitType === "Unit"
              ? currPrd?.measurementUnit
              : currPrd?.subMeasurementUnit}
          </Typography>
        </div>
        <div className="w20Per pr5">
          <Typography className="fs12 font-medium black4">
            {li?.dosage}
            {getRightPackageUom(
              li?.batchId
                ? (getBatchList(li?.stockId)?.find(
                    (bat) => bat?.batchId === li?.batchId,
                  )?.packageUom ?? "")
                : (getBatchList(li?.stockId)?.[0]?.packageUom ?? ""),
            )}
          </Typography>
        </div>
        <div className="w10Per pr5">
          <Typography className="fs12 font-medium black4">
            {li?.duration ?? "1"} days
          </Typography>
        </div>
        <div className="w10Per pr5">
          {(typeof li?.frequency === "string" && li?.frequency?.length > 0) ||
          (typeof li?.frequencyDuration === "string" &&
            li?.frequencyDuration?.length > 0) ||
          li?.morning ||
          li?.afternoon ||
          li?.night ? (
            <div className="fs12 font-medium black4">
              {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
                ? (li?.frequency ?? li?.frequencyDuration)
                : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
                    li?.night ? "1" : "0"
                  }`}
            </div>
          ) : // <div className="flex-start">
          //   <div className="blue-back-con fs12 font-medium">
          //     {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
          //       ? li?.frequency ?? li?.frequencyDuration
          //       : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
          //           li?.night ? "1" : "0"
          //         }`}
          //   </div>
          // </div>
          null}
        </div>
        <div className="w10Per pr5">
          <div className="fs12 font-medium black4">
            {mealTypesEnum?.[li?.meal ?? ""]}
          </div>
        </div>
        <div className="w10Per">
          <div className="fs12 font-medium black4">{li?.remark ?? ""}</div>
        </div>
      </div>
      // <div className="gray-back-con" key={`rec_${li?.id ?? li?.i}`}>
      //   <div className="flex-row flex-row-wrap">
      //     <div className="w85Per">
      //       <div className="flex-row flex-row-wrap">
      //         <div className="font-bold fs12 black">
      //           {li?.name ?? li?.plName}
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Quantity:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.quantity ?? li?.qty ?? "1"}{" "}
      //             {li?.subUnit === "Unit" || li?.unitType === "Unit"
      //               ? currPrd?.measurementUnit
      //               : currPrd?.subMeasurementUnit}
      //           </div>
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Dosage:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.dosage}
      //             {getRightPackageUom(
      //               li?.batchId
      //                 ? getBatchList(li?.stockId)?.find(
      //                     (bat) => bat?.batchId === li?.batchId
      //                   )?.packageUom ?? ""
      //                 : getBatchList(li?.stockId)?.[0]?.packageUom ?? ""
      //             )}
      //           </div>
      //         </div>
      //         <div className="flex-row flex-center ml10">
      //           <div className="gray-dot" />
      //           <div className="font-medium fs12 black4 ml5">Duration:</div>
      //           <div className="txt-regular fs12 black4 ml3">
      //             {li?.duration ?? "1"} days
      //           </div>
      //         </div>
      //         {li?.meal?.length > 0 ? (
      //           <div className="flex-row flex-center ml10">
      //             <div className="gray-dot" />
      //             <div className="txt-regular fs12 black4 ml5">
      //               {li?.meal === "afterMeal"
      //                 ? "After Meal"
      //                 : li?.meal === "beforeMeal"
      //                 ? "Before Meal"
      //                 : ""}
      //             </div>
      //           </div>
      //         ) : null}
      //       </div>
      //     </div>
      //     {(typeof li?.frequency === "string" && li?.frequency?.length > 0) ||
      //     (typeof li?.frequencyDuration === "string" &&
      //       li?.frequencyDuration?.length > 0) ||
      //     li?.morning ||
      //     li?.afternoon ||
      //     li?.night ? (
      //       <div className="flex-center">
      //         <div className="blue-back-con fs12 font-medium">
      //           {typeof (li?.frequency ?? li?.frequencyDuration) === "string"
      //             ? li?.frequency ?? li?.frequencyDuration
      //             : `${li?.morning ? "1" : "0"}-${li?.afternoon ? "1" : "0"}-${
      //                 li?.night ? "1" : "0"
      //               }`}
      //         </div>
      //       </div>
      //     ) : null}
      //   </div>
      // </div>
    );
  };

  return (
    <div>
      {/* <div className="blk-hor-split mv3" /> */}
      <div className="flex-row-ali-cen ph10">
        <div className="w30Per">
          <Typography className="fs12 txt-semi-bold black">Name</Typography>
        </div>
        <div className="w10Per">
          <Typography className="fs12 txt-semi-bold black">Qty</Typography>
        </div>
        <div className="w20Per">
          <Typography className="fs12 txt-semi-bold black">Dosage</Typography>
        </div>
        <div className="w10Per">
          <Typography className="fs12 txt-semi-bold black">Duration</Typography>
        </div>
        <div className="w10Per">
          <Typography className="fs12 txt-semi-bold black">
            Frequency
          </Typography>
        </div>
        <div className="w10Per">
          <Typography className="fs12 txt-semi-bold black">
            Instructions
          </Typography>
        </div>
        <div className="w10Per">
          <Typography className="fs12 txt-semi-bold black">Remarks</Typography>
        </div>
      </div>
      <div className="blk-hor-split mb3 mt10" />
      {(prescriptions ?? reqDet?.prescription)?.map((pres, i) => {
        return (
          <div className="mv5" key={`mainLi_${i}`}>
            {pres?.prescriptionDetails?.map((li) => {
              const currPrd = clinicStocks?.data?.find(
                (dta) => dta?.stockId === li?.stockId,
              );
              return renderData(li, currPrd);
            })}
            {/* <Typography className="fs12 txt-regular black mt10">
          {pres?.remarks}
        </Typography> */}
          </div>
        );
      })}
      {/* <div className="blk-hor-split mv3" /> */}
    </div>
  );
};

export default PrescriptionView;
